// Stub file for layout constants
export const topNavigationHeight = 64;
export const footerID = 'footer';
export const leftNavID = 'left-nav';
export const mainID = 'main';
export const rightNavID = 'right-nav';
export const secondaryNavID = 'secondary-nav';
export const topNavQuerySelector = '[data-testid="top-navigation"]';
